import { mainAxios } from "libs/axios";

/** 작품 정보 타입 */
export interface Artwork {
  artworkName: string | undefined;
  id: string;
  title: string;
  artist: string;
  authorName: string;
  artSize: string;
  image: string;
  profitRate?: number; // 수익률
  sellRate?: number; // 매각률
  holdingDays?: number; // 실제 보유기간
  transferPrice: number; // 매각금액
}

/** top30-artworks API 응답 타입 */
export interface Top30ArtworksResponse {
  artworks: Artwork[];
  success: boolean;
  message?: string;
}

/** top30-artworks API 호출 */
export const getTop30ArtworksApi = () => {
  return mainAxios.request({
    methodType: "GET",
    url: `/event/top30-artworks`,
    notError: true,
    config: {
      headers: {
        contentType: "application/json",
      },
    },
  });
};

/** 투자하기 API 요청 타입 */
export interface InvestRequest {
  investItems: string[];
}

/** 투자하기 API 응답 타입 */
export interface InvestResponse {
  success: boolean;
  message?: string;
  data?: any;
}

/** 투자하기 API 호출 */
export const investArtworksApi = (payload: InvestRequest) => {
  return mainAxios.request({
    methodType: "POST",
    url: `/event/invest`,
    payload: payload,
    requiresToken: true,
    notError: true,
    config: {
      headers: {
        contentType: "application/json",
      },
    },
  });
};

/** 랭킹 정보 타입 */
export interface RankingUser {
  rank: number;
  artworks: Artwork[];
  investId: number;
  phoneLast4: string;
  profit: string;
  userId: string;
  userName: string;
}

/** 랭킹 API 응답 타입 */
export interface RankingResponse {
  success: boolean;
  data: {
    topRankings: RankingUser[];
    myRanking: RankingUser;
    totalParticipants: number;
  };
}

/** 랭킹 조회 API 호출 */
export const getRankingApi = () => {
  return mainAxios.request({
    methodType: "POST",
    url: `/event/ranking`,
    requiresToken: true,
    notError: true,
    config: {
      headers: {
        contentType: "application/json",
      },
    },
  });
};
